
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64.374 53.969"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M63.663 28.376L49.052 2.704A5.274 5.274 0 0041.77.733l-39.11 22.9a5.433 5.433 0 00-1.949 7.36l11.541 20.278H6.705a1.35 1.35 0 000 2.7h50.963a1.35 1.35 0 000-2.7H35.186l26.528-15.538a5.432 5.432 0 001.949-7.358zM4.009 25.965L43.09 3.076l-9.266 26.282a2.68 2.68 0 01-2.309 1.5l-28.456-3.85a2.6 2.6 0 01.95-1.043zm56.356 7.437l-30.51 17.869H15.344L3.087 29.733 31.3 33.549h.135a5.319 5.319 0 004.765-2.94 1.313 1.313 0 00.114-.242L45.9 3.18a2.63 2.63 0 01.824.863l14.61 25.673a2.721 2.721 0 01-.969 3.686z"}})])
          )
        }
      }
    